module.exports = __webpack_public_path__ + "img/loader.ae1e752f.gif";